import { Link } from 'react-router-dom';
import { Check, ShoppingCart } from 'lucide-react';

const formatPrice = (price) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(price);

export default function UnitOnlyCard({ product, onAddToCart }) {
  return (
    <div
      className="bg-white rounded-xl p-6 flex flex-col relative transition-all duration-300 hover:shadow-xl border border-gray-100"
      data-testid={`unit-card-${product.id}`}
    >
      {/* Product Image */}
      <Link to={`/unit-only/${product.slug || product.id}`} className="block bg-gray-50 rounded-xl h-64 flex items-center justify-center mb-5 overflow-hidden" data-testid={`unit-image-link-${product.id}`}>
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} className="w-full h-full object-contain p-4" />
        ) : (
          <div className="text-center p-4">
            <div className="font-bold text-4xl text-emerald-700">{product.tonnage}</div>
            <div className="text-base text-gray-500 mt-2">{product.seer_rating}</div>
          </div>
        )}
      </Link>

      {/* Title */}
      <Link to={`/unit-only/${product.slug || product.id}`} data-testid={`unit-name-link-${product.id}`}>
        <h3 className="font-bold text-gray-900 text-lg leading-snug mb-4 hover:text-emerald-700 transition-colors" data-testid={`unit-name-${product.id}`}>
          {product.name}
        </h3>
      </Link>

      {/* Model */}
      <p className="text-sm text-gray-400 mb-4">Model: {product.model_number}</p>

      {/* Features */}
      <div className="mb-5 space-y-2">
        {['Air Handler', 'Condenser', 'Heating Element'].map((f, i) => (
          <div key={i} className="flex items-center gap-2.5 text-sm text-gray-600">
            <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" />
            <span>{f}</span>
          </div>
        ))}
      </div>

      {/* Pricing - show MAP price only */}
      <div className="mt-auto pt-5 border-t border-gray-100">
        <div className="mb-4" data-testid={`unit-map-price-${product.id}`}>
          <span className="font-bold text-2xl text-gray-900">{formatPrice(product.map_price)}</span>
        </div>

        <button
          onClick={() => onAddToCart(product)}
          className="w-full px-6 py-4 rounded-lg transition-colors text-lg"
          style={{ backgroundColor: '#FACC15', color: '#DC2626', fontWeight: 900 }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = '#FDE047'}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FACC15'}
          data-testid={`unit-reveal-btn-${product.id}`}
        >
          Add to Cart For Discount
        </button>
      </div>
    </div>
  );
}
